import { getErrorMessage } from "@/core/api/helpers"
import { useAppDispatch } from "@/redux/hooks"
import { useDeleteAdminSpamAccountMutation } from "@/redux/services/adminSpamAccountsApi"
import { setToast } from "@/redux/toastSlice"

export const useDeleteSpamAccount = () => {
  const dispatch = useAppDispatch()
  const [deleteSpamAccount, response] = useDeleteAdminSpamAccountMutation()

  const handleDeleteSpamAccount = async (id: string) => {
    try {
      const response = await deleteSpamAccount({ id }).unwrap()
      if (response) {
        dispatch(
          setToast({
            show: true,
            variant: "success",
            message: "Success delete spam account",
          }),
        )
      }
      return response
    } catch (error: any) {
      const message = getErrorMessage(error)
      dispatch(
        setToast({
          show: true,
          variant: "error",
          message,
        }),
      )
    }
  }

  return { deleteSpamAccount: handleDeleteSpamAccount, response }
}
